<template>
  <main>
    <customer-info :loading="false" />
    <div class="tab-header">
      <div class="container-fluid">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a href='#tab-0' class="nav-link active show" role="tab" data-toggle="tab">基本資料</a>
          </li>
          <li class="nav-item">
            <a href='#tab-1' class="nav-link" role="tab" data-toggle="tab">家戶關係</a>
          </li>
          <li class="nav-item">
            <a href='#tab-2' class="nav-link" role="tab" data-toggle="tab">紀錄簿</a>
          </li>
          <li class="nav-item">
            <a href='#tab-3' class="nav-link" role="tab" data-toggle="tab">保單資訊</a>
          </li>
          <li class="nav-item">
            <a href='#tab-4' class="nav-link" role="tab" data-toggle="tab">服務歷程</a>
          </li>
          <li class="nav-item">
            <a href='#tab-5' class="nav-link" role="tab" data-toggle="tab">申辦進度</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <div class="container-fluid">
        <div id="tab-0" class="tab-pane active show" role="tabpanel">
          <div class="row with-divider">
            <div class="col-7">
              <h4 class="text-green mt-0">
                <a role="button" class="btn btn-default btn-icon btn-sm float-right m-0">
                  <i class="icon-edit"></i>
                </a>
                個人資訊
              </h4>
              <div class="row">
                <div class="col-6">
                  <div class="item row">
                    <div class="col-4 label">身份註記</div>
                    <div class="col-8 text">— —</div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">LINE ID</div>
                    <div class="col-8 text">— —</div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">職業</div>
                    <div class="col-8 text">— —</div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">服務單位</div>
                    <div class="col-8 text">— —</div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">婚姻</div>
                    <div class="col-8 text">— —</div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="item row">
                    <div class="col-4 label">客戶關係</div>
                    <div class="col-8 text">— —</div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">Email</div>
                    <div class="col-8 text">— —</div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">介紹人</div>
                    <div class="col-8 text">
                      — —
                    </div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">學歷</div>
                    <div class="col-8 text">— —</div>
                  </div>
                </div>
              </div>
              <hr>
              <h4 class="text-green">拒絕行銷</h4>
              <div class="row px-5">
                <div class="col-4 sale-item">
                  <i class="icon-check"></i>
                  <span class="text">簡訊行銷</span>
                </div>
                <div class="col-4 sale-item">
                  <i class="icon-check"></i>
                  <span class="text">電話行銷</span>
                </div>
                <div class="col-4 sale-item">
                  <i class="icon-check"></i>
                  <span class="text">Email行銷</span>
                </div>
                <div class="col-4 sale-item">
                  <i class="icon-check"></i>
                  <span class="text">郵寄行銷</span>
                </div>
                <div class="col-8 sale-item">
                  <i class="icon-check"></i>
                  <span class="text">業務人員行銷(非經手或服務人員)</span>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="error-block text-center">
                    <span class="error">
                      <span class="text-red">＊</span>
                      <span class="text-black">此客戶拒絕共同行銷</span>
                    </span>
                  </div>
                </div>
              </div>
              <hr>
              <h4 class="text-green">
                <a role="button" class="btn btn-default btn-icon btn-sm float-right m-0">
                  <i class="icon-edit"></i>
                </a>
                財務狀況
              </h4>
              <div class="row">
                <div class="col-6">
                  <div class="item row">
                    <div class="col-5 label">家庭年收入</div>
                    <div class="col-7 text">— —</div>
                  </div>
                  <div class="item row">
                    <div class="col-5 label">個人年所得</div>
                    <div class="col-7 text">— —</div>
                  </div>
                  <div class="item row">
                    <div class="col-5 label">月平均投資</div>
                    <div class="col-7 text">— —</div>
                  </div>
                  <div class="item row">
                    <div class="col-5 label">理財工具</div>
                    <div class="col-7 text">— —</div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="item row">
                    <div class="col-4 label">房貸金額</div>
                    <div class="col-8 text">— —</div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">住屋狀況</div>
                    <div class="col-8 text">— —</div>
                  </div>
                  <div class="item row">
                    <div class="col-4 label">交通工具</div>
                    <div class="col-8 text">— —</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-5">
              <h4 class="text-green mt-0">服務申辦項目</h4>
              <div class="button-grid cards two-card px-0 pb-0">
                <a class="card text-center no-shadow"
                v-for="(btn, bid) in serviceItems"
                :class="btn.status===0 ? 'disabled': ''"
                :key="`notification-item-${bid}`">
                  <h6 class="m-0">{{btn.name}}</h6>
                  <small v-if="btn.status!=0" class="text-orange mt-1">
                    {{ btn.status }}
                  </small>
                  <small class="text-red text-thin mt-1" v-else>尚未申辦</small>
                </a>
              </div>
              <div v-if="serviceNotification.length && serviceNotification.length > 6">
                <a
                class="link text-underline collapse-item"
                v-if="!serviceNotificationCollapse"
                @click.stop.prevent="serviceNotificationCollapse = true">
                  顯示更多 <i class="icon-collapse_down"></i>
                </a>
                <a class="link text-underline collapse-item"
                v-else
                @click.stop.prevent="serviceNotificationCollapse = false">
                  收合顯示 <i class="icon-collapse_up"></i>
                </a>
              </div>
              <h4 class="text-green">行銷目標通知</h4>
              <div class="button-grid two-items px-0 pb-0"
              v-if="saleNotification.length">
                <a class="btn btn-border-green"
                v-show="saleNotificationCollapse || (!saleNotificationCollapse && bid < 6)"
                v-for="(btn, bid) in saleNotification"
                :key="`sale-item-${bid}`">
                  {{btn}}
                </a>
              </div>
              <div class="mt-3" v-else>
                <div class="gray-block">目前沒有任何通知</div>
              </div>
              <div v-if="saleNotification.length && saleNotification.length > 6">
                <a
                class="link text-underline collapse-item"
                v-if="!saleNotificationCollapse"
                @click.stop.prevent="saleNotificationCollapse = true">
                  顯示更多 <i class="icon-collapse_down"></i>
                </a>
                <a class="link text-underline collapse-item"
                v-else
                @click.stop.prevent="saleNotificationCollapse = false">
                  收合顯示 <i class="icon-collapse_up"></i>
                </a>
              </div>
              <h4 class="text-green">
                <a role="button" class="btn btn-default btn-icon btn-sm float-right m-0">
                  <i class="icon-edit"></i>
                </a>
                群組
              </h4>
              <div class="button-grid two-items px-0 pb-0"
              v-if="group.length">
                <a class="btn btn-border-green"
                @click="selectGroup(btn)"
                v-show="groupCollapse || (!groupCollapse && bid < 6)"
                v-for="(btn, bid) in group"
                :key="`group-item-${bid}`">
                  {{btn}}
                </a>
              </div>
              <div class="mt-3" v-else>
                <div class="gray-block">目前不屬於任何群組</div>
              </div>
              <div v-if="group.length && group.length > 6">
                <a
                class="link text-underline collapse-item"
                v-if="!groupCollapse"
                @click.stop.prevent="groupCollapse = true">
                  顯示更多 <i class="icon-collapse_down"></i>
                </a>
                <a class="link text-underline collapse-item"
                v-else
                @click.stop.prevent="groupCollapse = false">
                  收合顯示 <i class="icon-collapse_up"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div id="tab-1" class="tab-pane" role="tabpanel">
          <div class="empty-block bg-white" v-if="!customer.family.length && !familyEditing">
            <h3>{{customer.info.name}}尚未屬於任何一個家戶</h3>
            <a class="btn btn-primary"
            @click="panelOpen('familyModalOpen')">
              加入現有家戶
            </a>
            <a class="btn btn-primary"
            @click="initFamily()">
              成立新的家戶
            </a>
          </div>
          <div v-else>
            <div class="row" v-if="familyEditing">
              <div class="col-12 mb-3 text-right">
                <a class="btn btn-default btn-sm m-0 mr-2"
                v-if="oldFamily.leader"
                :disabled="oldFamily.leader && !customer.family.length"
                @click="beforeClearFamily()">
                  刪除家戶
                </a>
                <a @click="cancelFamilyEdit()" class="btn btn-default btn-sm m-0 mr-2">
                  取消
                </a>
                <a @click="submitFamilyEdit()" class="btn btn-primary btn-sm m-0 mr-2">
                  儲存
                </a>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-12 mb-3">
                <a @click="editFamily()" class="btn btn-default btn-sm btn-icon m-0 float-right">
                  <i class="icon-edit"></i>
                </a>
              </div>
            </div>
            <div class="cards family">
              <div class="card"
              v-for="(card, rid) in customer.family"
              :key="`family-card-${rid}`">
                <a class="close"
                v-if="familyEditing && (rid > 0 && !card.currentCustomer)"
                @click="removeMember(rid, card)">
                  <i class="icon-close"></i>
                </a>
                <h3 v-if="!card.link">{{card.name}}</h3>
                <h3 v-else>
                  <router-link to="/detail/1/empty" class="link text-underline">
                    {{card.name}}
                  </router-link>
                </h3>
                <div class="content">
                  <div class="desc role">
                    <avatar :lv="customer.info.gender" :size="20" />
                    <span class="text" v-if="familyEditing && rid > 0">
                      <select v-model="card.role" class="form-control form-control-inline form-short">
                        <option v-for="(role, j) in roleOpt" :key="`role-select-${j}`">
                          {{role}}
                        </option>
                      </select>
                    </span>
                    <span class="text" v-else>
                      {{card.role}}
                    </span>
                  </div>
                </div>
                <div class="desc">{{card.identity}}</div>
                <div class="desc">
                  <b class="float-right">{{card.birthday | ageCounter}}歲</b>
                  {{card.birthday | dateFormat}}
                </div>
              </div>
              <div class="card add"
              v-if="familyEditing && customer.family.length"
              @click="panelOpen('addFamilyModalOpen')">
                <div class="icon">
                  <i class="icon-add_new text-orange i-32"></i>
                </div>
                <div class="p">新增家戶成員</div>
              </div>
            </div>
          </div>
        </div>
        <div id="tab-2" class="tab-pane" role="tabpanel">
        </div>
        <div id="tab-3" class="tab-pane" role="tabpanel">
          <div class="row">
            <div class="col-8">
              <div class="radio radio-inline">
                <input type="radio" name="filter" id="filter-1" v-model="insuranceFilter" value="0">
                <label for="filter-1">全部保單</label>
              </div>
              <div class="radio radio-inline">
                <input type="radio" name="filter" id="filter-2" v-model="insuranceFilter" value="1">
                <label for="filter-2">資產檢視</label>
              </div>
              <div class="radio radio-inline">
                <input type="radio" name="filter" id="filter-3" v-model="insuranceFilter" value="2">
                <label for="filter-3">保障檢視</label>
              </div>
            </div>
            <div class="col-4 text-right">
              <button class="btn btn-sm btn-primary" disabled>編輯保單</button>
              <button class="btn btn-sm btn-primary mr-0" disabled>全部展開</button>
            </div>
          </div>
          <div class="empty">
            <h3 class="text-gray text-center">此客戶尚未有任何保單資訊</h3>
          </div>
        </div>
        <div id="tab-4" class="tab-pane" role="tabpanel">
        </div>
        <div id="tab-5" class="tab-pane" role="tabpanel">
        </div>
      </div>
    </div>
    
    <warning-modal
    :open="warningModalOpen"
    :message="warningData[currentWarningType].message"
    @close="panelClose('warningModalOpen')"
    @submit="warningSubmit"/>

    <family-modal
    :open="familyModalOpen"
    @close="panelClose('familyModalOpen')"
    @submit="submitFamily"/>

    <group-member-modal
    :open="groupModalOpen"
    :group="selectedGroup"
    @close="panelClose('groupModalOpen')"
    />

    <add-family-modal
    :open="addFamilyModalOpen"
    :customer="customer.info"
    @close="panelClose('addFamilyModalOpen')"
    @submit="submitAddFamily"/>

  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '../../mixins/common'
import Level from '../../components/Level'
import Avatar from '../../components/Avatar'
import GroupMemberModal from '../components/GroupMemberModal'
import FamilyModal from '../components/FamilyModal'
import AddFamilyModal from '../components/AddFamilyModal'
import WarningModal from '../components/WarningModal'
import { getCustomers } from '../../service/index';

const customer = {
  info: {
    lv: 0,
    gender: -1,
    birthday: '',
    name: '林怡君',
    mobile: '',
    familyLeader: false,
    phone: '02-28223521',
    fax: '',
    ID: '',
    office_phone: '',
    address: '',
    office_address: '',
  },
  iaa: {
    mobile: '0922133647',
    phone: '02-28223521',
    address: '112 台北市北投區光明路251號',
    email: 'Green@tree.com.tw'
  },
  decline: [],
  family: []
}

export default {
  name: 'CustomerDetail',
  mixins: [commonMixin],
  computed: {
    ...mapGetters(['BaseUrl'])
  },
  data () {
    return {
      insuranceFilter: 0,
      currentTab: 0,
      customer: customer,
      familyEditing: false,
      oldFamily: [],
      serviceNotificationCollapse: false,
      saleNotificationCollapse: false,
      groupCollapse: false,
      warningModalOpen: false,
      addFamilyModalOpen: false,
      familyModalOpen: false,
      groupModalOpen: false,
      selectedGroup: null,
      serviceNotification: [],
      saleNotification: [],
      currentDelIndex: 0,
      currentWarningType: 'delFamily',
      warningData: {
        delFamily: {
          message: '您是否確認要刪除家戶成員 簡沛文 ，若確定刪除，則簡沛文 需重新歸戶。',
          submit: 'delFamily'
        },
        clearFamily: {
          message: '您是否確認要刪除以 <b></b> 為戶長之家戶，若確定刪除，則原家戶成員皆須重新歸戶。',
          submit: 'clearFamily'
        },
        becomeLeader: {
          message: '是否確認要修改 <b></b> 的家戶關係？',
          submit: 'becomeLeader'
        }
      },
      serviceItems: [
        {
          name: '網路服務線上變更',
          status: 0
        },
        {
          name: '行動服務',
          status: 0
        },
        {
          name: 'ID一指通',
          status: 0
        },
        {
          name: '電子單據',
          status: 0
        },
        {
          name: '轉帳申請',
          status: 0
        },
        {
          name: '易Call保',
          status: 0
        },
        {
          name: '保單貸款',
          status: 0
        },
        {
          name: '理賠抵繳',
          status: 0
        }
      ],
      group: [],
      roleOpt: ['戶長', '配偶', '子女', '其他']
    }
  },
  components: { GroupMemberModal, FamilyModal, WarningModal, AddFamilyModal, Level, Avatar },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    
    removeMember(i, data) {
      this.currentDelIndex = i
      this.currentWarningType = 'delFamily'
      this.warningData[this.currentWarningType].message = `您是否確認要刪除家戶成員 <a class="link text-underline">${data.name}<a/> ，若確定刪除，則<a class="link text-underline">${data.name}<a/> 需重新歸戶。`
      this.panelOpen('warningModalOpen')
    },
    warningSubmit () {
      let fn = this.warningData[this.currentWarningType].submit
      this[fn]()
      this.panelClose('warningModalOpen')
    },
    delFamily() {
      this.customer.family.splice(this.currentDelIndex, 1)
    },
    initFamily() {
      this.recordOrResetFamily()
      this.familyEditing = true
      
      let item = [{
        link: 1,
        name: this.customer.info.name,
        gender: 0,
        identity: 'A223456789',
        role: '戶長',
        birthday: '19600809',
        currentCustomer: true
      }]
      this.customer.info.familyLeader = true
      this.customer.family = item
    },
    submitAddFamily (item) {
      this.customer.family = this.customer.family.concat(item)
      this.panelClose('addFamilyModalOpen')
    },
    submitFamily(f) {
      // add family item from api
      this.recordOrResetFamily()
      this.familyEditing = true
      let item = [
        {
          link: 1,
          name: '陳怡君',
          gender: 0,
          identity: 'A223456789',
          role: '戶長',
          birthday: '19600809'
        },
        {
          name: '王大進',
          gender: 1,
          identity: 'A223456789',
          role: '配偶',
          birthday: '19600809'
        },
        {
          name: '王潔心',
          gender: 0,
          identity: 'A223456789',
          role: '子女',
          birthday: '19600809'
        },
        {
          name: '簡沛文',
          gender: -1,
          identity: 'A223456789',
          role: '其他',
          birthday: '19600809'
        },
        {
          link: 1,
          name: '陳潔妮',
          gender: -1,
          identity: 'A223456789',
          role: '其他',
          birthday: '19600809'
        },
        {
          name: '端木王大進',
          gender: -1,
          identity: 'A223456789',
          role: '其他',
          birthday: '19600809'
        }
      ]

      item.push({
        link: 1,
        name: this.customer.info.name,
        gender: 0,
        identity: 'A223456789',
        role: '其他',
        birthday: '19600809',
        currentCustomer: true
      })
      this.customer.info.familyLeader = false
      this.customer.family = item
      this.panelClose('familyModalOpen')
    },
    beforeClearFamily () {
      this.currentWarningType = 'clearFamily'
      this.warningData.clearFamily.message = `您是否確認要刪除以 <b>${customer.info.name}</b> 為戶長之家戶，若確定刪除，則原家戶成員皆須重新歸戶。`
      this.panelOpen('warningModalOpen')
    },
    clearFamily () {
      this.recordOrResetFamily()
      this.familyEditing = true
      this.customer.family = []
      this.customer.info.familyLeader = false
      this.panelClose('warningModalOpen')
    },
    recordOrResetFamily (reset) {
      if(reset) {
        this.customer.info.familyLeader = this.oldFamily.leader
        this.customer.family = this.oldFamily.family
      } else {
        this.oldFamily = {
          leader: window._.clone(this.customer.info.familyLeader),
          family: window._.clone(this.customer.family)
        }
      }
    },
    cancelFamilyEdit () {
      this.recordOrResetFamily(true)
      this.familyEditing = false
    },
    becomeLeader () {
      this.panelClose('warningModalOpen')
      this.familyEditing = false
    },
    submitFamilyEdit () {
      if (!this.oldFamily.leader && this.customer.info.familyLeader) {
        this.warningData.becomeLeader.message = `是否確認要修改<b>${this.customer.info.name}</b> 的家戶關係？`
        this.currentWarningType = 'becomeLeader'
        this.panelOpen('warningModalOpen')
      } else {
        this.familyEditing = false
      }
    },
    editFamily () {
      this.recordOrResetFamily()
      this.familyEditing = true
    },
    selectGroup(item) {
      this.selectedGroup = item
      this.panelOpen('groupModalOpen')
    }
  },async mounted () {
    await getCustomers(this.$route.params.id).then(r => {
      this.customer.info = r[0]
    })
  }
}
</script>
